import React, { Component } from "react";
import { connect } from "react-redux";
import Icon from "../icon/index";
import "./style.scss";
import { withRouter, Link } from "react-router-dom";
import { Text } from "@sitecore-jss/sitecore-jss-react";
import classNames from "classnames";
import { addTransition } from "../../redux/actions/actions";
import { toggleIframe } from "../../redux/actions/model";
import { openModal } from "../../utils";

class IconLink extends Component {
  handleClick(event) {
    event.preventDefault();
    const { isPageTransition, pageTransitionTitle, pageTransitionCurtainColor, pageTransitionCurtainDirection, isShowModal, nestedGrid, link, toggleIframe, addTransition, callback, isDisabled } = this.props;
    if (isDisabled && isDisabled.value) {
      return false;
    }
    if (isShowModal && isShowModal.value) {
      toggleIframe("", nestedGrid.value);
      openModal(link.value.id);
      return false;
    }
    if (isPageTransition && isPageTransition.value) {
      addTransition(
        "page-curtain",
        link && link.value.href,
        pageTransitionTitle && pageTransitionTitle.value,
        (pageTransitionCurtainDirection && pageTransitionCurtainDirection.fields && pageTransitionCurtainDirection.fields.phrase.value === "right-to-left") || false,
        link && link.value.linktype,
        pageTransitionCurtainColor && pageTransitionCurtainColor.fields && pageTransitionCurtainColor.fields.phrase.value
      );
      return;
    }

    if (this.props.onClick) {
      this.props.onClick();
    }
    if (Object.prototype.toString.call(callback) === "[object Function]") {
      callback(event);
    }
  }

  render() {
    const { isDisabled, colorScheme, iconName, link, id, buttonText, callback, onClick, className } = this.props;
    const icon = { ...{ icon: iconName ? iconName.value : "" } };
    const classes = classNames(className, "icon-link", colorScheme?.fields?.phrase?.value, {
      disabled: (isDisabled && isDisabled.value) || isDisabled === true
    });

    if (link?.value?.href?.startsWith("mailto:tel:")) {
      link.value.href = link.value.href.replace("mailto:tel:", "tel:");
    }

    const innerButtonContent = () => {
      return (
        <span className="icon-link__content" tabIndex="-1">
          {iconName != null && (
            <div className="icon-container">
              <Icon {...icon} />
            </div>
          )}
          <Text
            tag="span"
            className="buttonText"
            field={{
              value: buttonText?.value || buttonText || (link && link?.value?.text)
            }}
          />
        </span>
      );
    };

    if (callback || onClick) {
      return (
        <button className={classes} onClick={this.handleClick.bind(this)} type="button" tabIndex="0" id={id}>
          {innerButtonContent()}
        </button>
      );
    }

    if (link?.value?.linktype === "internal") {
      return (
        <Link to={link?.value?.href} target={link?.value?.target} className={classes} tabIndex="0" id={id}>
          {innerButtonContent()}
        </Link>
      );
    }

    return (
      <a className={classes} tabIndex="0" id={id} href={link?.value?.href} target={link?.value?.target}>
        {innerButtonContent()}
      </a>
    );
  }
}
const mapDispatchToProps = {
  addTransition: addTransition,
  toggleIframe: toggleIframe
};
export default withRouter(connect(null, mapDispatchToProps)(IconLink));
